import { createThunkRoutine } from 'redux-thunk-routine';

export const FetchSurveysRoutine = createThunkRoutine('surveys/FETCH_SURVEYS');
export const CreateSurveysRoutine = createThunkRoutine('surveys/CREATE_SURVEY');
export const DeleteSurveyRoutine = createThunkRoutine('surveys/DELETE_SURVEY');
export const FetchSurveyRoutine = createThunkRoutine('surveys/FETCH_SURVEY');
export const CreateQuestionRoutine = createThunkRoutine('surveys/CREATE_QUESTION');
export const DeleteQuestionRoutine = createThunkRoutine('surveys/DELETE_QUESTION');
export const AssignUserRoutine = createThunkRoutine('surveys/ASSIGN_USER');
export const UnassignUserRoutine = createThunkRoutine('surveys/UNASSIGN_USER');
export const UpdateSurveyRoutine = createThunkRoutine('surveys/UPDATE_SURVEY');